const isEnter = e => e.key === 'Enter' || e.keyCode === 13
const isSpace = e => e.key === 'Space' || e.keyCode === 32

export const onKeyDownSubmit = (callback, allowSpace = true) => event => {
  if (isEnter(event) || (allowSpace && isSpace(event))) {
    event.preventDefault()
    callback()
  }
}
